var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container registration-form my-3" },
    [
      _vm.userHash
        ? _c("modal-verify-email-component", {
            attrs: { userEmail: _vm.userEmail, userHash: _vm.userHash }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "row justify-content-center" }, [
        _c("div", { staticClass: "col-md-12" }, [
          _c(
            "form",
            { staticClass: "form-register" },
            [
              _c("h1", { staticClass: "text-center mb-4" }, [
                _vm._v(_vm._s(_vm.translate.login.register))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("h2", { staticClass: "heading-xl" }, [
                    _vm._v(_vm._s(_vm.translate.login.memberType))
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "user-types error-input-container",
                      class: {
                        "has-error":
                          _vm.formSubmitted && !_vm.$v.memberType.memberTypeEnum
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "user-type",
                          class: {
                            active: _vm.memberType === _vm.MemberTypeEnum.ESCORT
                          },
                          attrs: { id: "userType1" },
                          on: {
                            click: function($event) {
                              _vm.memberType = _vm.MemberTypeEnum.ESCORT
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "logo" },
                            [
                              _c("icon-component", {
                                attrs: { icon: _vm.fa_person_half_dress() }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.translate.login.userRegistrationTypes[1]
                              )
                            )
                          ]),
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.translate.login
                                  .userRegistrationTypesDescription[1]
                              ) +
                              "\n                        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "user-type",
                          class: {
                            active: _vm.memberType === _vm.MemberTypeEnum.PUNTER
                          },
                          attrs: { id: "userType0" },
                          on: {
                            click: function($event) {
                              _vm.memberType = _vm.MemberTypeEnum.PUNTER
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "logo" },
                            [
                              _c("icon-component", {
                                attrs: { icon: _vm.fa_child_reaching() }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.translate.login.userRegistrationTypes[0]
                              )
                            )
                          ]),
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.translate.login
                                  .userRegistrationTypesDescription[0][0]
                              )
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.translate.login
                                  .userRegistrationTypesDescription[0][1]
                              ) +
                              "\n                        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "user-type",
                          class: {
                            active: _vm.memberType === _vm.MemberTypeEnum.VENUE
                          },
                          attrs: { id: "userType3" },
                          on: {
                            click: function($event) {
                              _vm.memberType = _vm.MemberTypeEnum.VENUE
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "logo" },
                            [
                              _c("icon-component", {
                                attrs: {
                                  viewBox: "250 0 512 512",
                                  width: "2em",
                                  icon: _vm.fa_house_person_return()
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.translate.login.userRegistrationTypes[3]
                              )
                            )
                          ]),
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.translate.login
                                  .userRegistrationTypesDescription[3]
                              ) +
                              "\n                        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "user-type",
                          class: {
                            active:
                              _vm.memberType === _vm.MemberTypeEnum.MANAGER
                          },
                          attrs: { id: "userType2" },
                          on: {
                            click: function($event) {
                              _vm.memberType = _vm.MemberTypeEnum.MANAGER
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "logo" },
                            [
                              _c("icon-component", {
                                attrs: {
                                  viewBox: "250 0 512 512",
                                  width: "2em",
                                  icon: _vm.fa_people_roof()
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.translate.login.userRegistrationTypes[2]
                              )
                            )
                          ]),
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.translate.login
                                  .userRegistrationTypesDescription[2][0]
                              )
                          ),
                          _c("br"),
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm.translate.login
                                  .userRegistrationTypesDescription[2][1]
                              ) +
                              "\n                        "
                          )
                        ]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm.formSubmitted && _vm.$v.memberType.$invalid
                    ? _c("error-component", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.translate.login.memberTypeSelect) +
                            "\n                    "
                        )
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("h2", { staticClass: "heading-xl" }, [
                _vm._v(_vm._s(_vm.translate.login.contactInfo))
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("live-country-component", {
                    attrs: { "post-fix-path": "/users/registration/" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "span",
                  {
                    staticClass: "error-input-container",
                    class: {
                      "has-error":
                        (_vm.$v.emailOrPhone.$error || _vm.formSubmitted) &&
                        (!_vm.$v.emailOrPhone.required || _vm.emailTaken)
                    }
                  },
                  [
                    _vm.memberType === _vm.MemberTypeEnum.ESCORT
                      ? _c("div", { staticClass: "input-group ml-auto" }, [
                          _c(
                            "select",
                            {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model.trim",
                                  value: _vm.$v.countryCodeId.$model,
                                  expression: "$v.countryCodeId.$model",
                                  modifiers: { trim: true }
                                }
                              ],
                              staticClass: "form-control p-1 mr-2",
                              attrs: {
                                id: "inputCountryCode",
                                "e2e-id": "input-country-code"
                              },
                              on: {
                                change: function($event) {
                                  var $$selectedVal = Array.prototype.filter
                                    .call($event.target.options, function(o) {
                                      return o.selected
                                    })
                                    .map(function(o) {
                                      var val =
                                        "_value" in o ? o._value : o.value
                                      return val
                                    })
                                  _vm.$set(
                                    _vm.$v.countryCodeId,
                                    "$model",
                                    $event.target.multiple
                                      ? $$selectedVal
                                      : $$selectedVal[0]
                                  )
                                }
                              }
                            },
                            _vm._l(_vm.countryCodes, function(country) {
                              return _c(
                                "option",
                                { domProps: { value: country.id } },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(country.emoji) +
                                        " " +
                                        _vm._s(country.dialCode)
                                    )
                                  ])
                                ]
                              )
                            }),
                            0
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model.trim",
                                value: _vm.$v.emailOrPhone.$model,
                                expression: "$v.emailOrPhone.$model",
                                modifiers: { trim: true }
                              }
                            ],
                            staticClass: "form-control pl-2",
                            attrs: {
                              id: "inputEmailOrPhone",
                              placeholder: _vm.translate.login.phonePlaceholder,
                              "e2e-id": "input-phone-number",
                              type:
                                _vm.memberType === _vm.MemberTypeEnum.ESCORT
                                  ? "number"
                                  : "text"
                            },
                            domProps: { value: _vm.$v.emailOrPhone.$model },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.$v.emailOrPhone,
                                  "$model",
                                  $event.target.value.trim()
                                )
                              },
                              blur: function($event) {
                                return _vm.$forceUpdate()
                              }
                            }
                          })
                        ])
                      : _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.$v.emailOrPhone.$model,
                              expression: "$v.emailOrPhone.$model",
                              modifiers: { trim: true }
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            id: "inputEmailOrPhone",
                            placeholder: _vm.translate.login.emailOrPhone,
                            type: "text"
                          },
                          domProps: { value: _vm.$v.emailOrPhone.$model },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.$v.emailOrPhone,
                                "$model",
                                $event.target.value.trim()
                              )
                            },
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        })
                  ]
                ),
                _vm._v(" "),
                _vm.$v.emailOrPhone.$error || _vm.formSubmitted
                  ? _c(
                      "span",
                      [
                        !_vm.$v.emailOrPhone.required
                          ? _c("error-component", {
                              attrs: {
                                message:
                                  _vm.memberType === _vm.MemberTypeEnum.ESCORT
                                    ? _vm.translate.login.phoneRequired
                                    : _vm.translate.login.emailRequired
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.emailNotValid
                          ? _c("error-component", {
                              attrs: {
                                message: _vm.translate.login.emailNotValid
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.phoneNotValid
                          ? _c("error-component", {
                              attrs: {
                                message: _vm.translate.login.phoneNotValid
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.emailOrPhoneTaken
                          ? _c(
                              "error-component",
                              {
                                attrs: {
                                  message: _vm.translate.login.emailOrPhoneTaken
                                }
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.regionRelativeUrl(
                                        "/users/forgot-password/"
                                      )
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.translate.login.emailOrPhoneTaken2
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(
                                  _vm._s(
                                    _vm.translate.login.emailOrPhoneTaken3
                                  ) + "\n                        "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.memberType === _vm.MemberTypeEnum.ESCORT &&
                (_vm.$v.countryCodeId.$error || _vm.formSubmitted)
                  ? _c(
                      "span",
                      [
                        !_vm.$v.countryCodeId.required
                          ? _c("error-component", {
                              attrs: {
                                message:
                                  _vm.translate.login.countryDialCodeRequired
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "span",
                  {
                    staticClass: "error-input-container",
                    class: {
                      "has-error":
                        (_vm.$v.username.$error || _vm.formSubmitted) &&
                        (!_vm.$v.username.required || _vm.usernameTaken)
                    }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.$v.username.$model,
                          expression: "$v.username.$model",
                          modifiers: { trim: true }
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        id: "inputUsername",
                        placeholder: _vm.translate.login.username,
                        type: "text"
                      },
                      domProps: { value: _vm.$v.username.$model },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.$v.username,
                            "$model",
                            $event.target.value.trim()
                          )
                        },
                        blur: function($event) {
                          return _vm.$forceUpdate()
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _vm.$v.username.$error || _vm.formSubmitted
                  ? _c(
                      "span",
                      [
                        !_vm.$v.username.required
                          ? _c("error-component", {
                              attrs: {
                                message: _vm.translate.login.usernameRequired
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.usernameTaken
                          ? _c("error-component", {
                              attrs: {
                                message: _vm.translate.login.usernameTaken
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "username-suggestions" },
                  _vm._l(_vm.suggestedUsernames, function(username, i) {
                    return _c(
                      "a",
                      {
                        key: i,
                        staticClass: "suggested-username",
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.applySuggestedUsername(username)
                          }
                        }
                      },
                      [_vm._v(_vm._s(username))]
                    )
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "span",
                  {
                    staticClass: "error-input-container",
                    class: {
                      "has-error":
                        (_vm.$v.password.$error || _vm.formSubmitted) &&
                        !_vm.$v.password.required
                    }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.$v.password.$model,
                          expression: "$v.password.$model",
                          modifiers: { trim: true }
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        id: "inputPassword",
                        placeholder: _vm.translate.login.password,
                        type: "password"
                      },
                      domProps: { value: _vm.$v.password.$model },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.$v.password,
                            "$model",
                            $event.target.value.trim()
                          )
                        },
                        blur: function($event) {
                          return _vm.$forceUpdate()
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _vm.$v.password.$error || _vm.formSubmitted
                  ? _c(
                      "span",
                      [
                        !_vm.$v.password.required
                          ? _c("error-component", {
                              attrs: {
                                message: _vm.translate.login.passwordRequired
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _c(
                  "span",
                  {
                    staticClass: "error-input-container",
                    class: {
                      "has-error":
                        (_vm.$v.passwordConfirm.$error || _vm.formSubmitted) &&
                        (!_vm.$v.passwordConfirm.required ||
                          !_vm.$v.passwordConfirm.sameAsPassword)
                    }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model.trim",
                          value: _vm.$v.passwordConfirm.$model,
                          expression: "$v.passwordConfirm.$model",
                          modifiers: { trim: true }
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        id: "inputPasswordConfirm",
                        placeholder: _vm.translate.login.confirmPassword,
                        type: "password"
                      },
                      domProps: { value: _vm.$v.passwordConfirm.$model },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.$set(
                            _vm.$v.passwordConfirm,
                            "$model",
                            $event.target.value.trim()
                          )
                        },
                        blur: function($event) {
                          return _vm.$forceUpdate()
                        }
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _vm.$v.passwordConfirm.$error || _vm.formSubmitted
                  ? _c(
                      "span",
                      [
                        !_vm.$v.passwordConfirm.required
                          ? _c("error-component", {
                              attrs: {
                                message: _vm.translate.login.passwordRepeat
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.$v.passwordConfirm.sameAsPassword
                          ? _c("error-component", {
                              attrs: {
                                message: _vm.translate.login.passwordDontMatch
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _vm.captcha && _vm.captcha.img
                ? _c("div", { staticClass: "form-group" }, [
                    _c(
                      "span",
                      {
                        staticClass: "error-input-container",
                        class: {
                          "has-error":
                            (_vm.$v.captchaInput.$error || _vm.formSubmitted) &&
                            (!_vm.$v.captchaInput.required ||
                              (_vm.captchaNotValid && !_vm.captchaInput))
                        }
                      },
                      [
                        _c("img", {
                          staticClass: "w-100",
                          attrs: { src: _vm.captcha.img }
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.$v.captchaInput.$model,
                              expression: "$v.captchaInput.$model",
                              modifiers: { trim: true }
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            id: "captchaInput",
                            type: "text",
                            placeholder:
                              _vm.translate.login.enterCaptchaPlaceholder
                          },
                          domProps: { value: _vm.$v.captchaInput.$model },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.$v.captchaInput,
                                "$model",
                                $event.target.value.trim()
                              )
                            },
                            blur: function($event) {
                              return _vm.$forceUpdate()
                            }
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _vm.$v.captchaInput.$error || _vm.formSubmitted
                      ? _c(
                          "span",
                          [
                            _vm.captchaNotValid && !_vm.captchaInput
                              ? _c("error-component", {
                                  attrs: {
                                    message:
                                      _vm.translate.login.enterCaptchaErrorWrong
                                  }
                                })
                              : !_vm.$v.captchaInput.required
                              ? _c("error-component", {
                                  attrs: {
                                    message:
                                      _vm.translate.login
                                        .enterCaptchaErrorRequired
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "from-check" }, [
                _c(
                  "div",
                  { staticClass: "form-check form-check--align-right" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.$v.acceptTerms.$model,
                          expression: "$v.acceptTerms.$model"
                        }
                      ],
                      staticClass: "form-check-input",
                      attrs: { id: "inputAcceptTerms", type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(_vm.$v.acceptTerms.$model)
                          ? _vm._i(_vm.$v.acceptTerms.$model, null) > -1
                          : _vm.$v.acceptTerms.$model
                      },
                      on: {
                        change: function($event) {
                          var $$a = _vm.$v.acceptTerms.$model,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(
                                  _vm.$v.acceptTerms,
                                  "$model",
                                  $$a.concat([$$v])
                                )
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  _vm.$v.acceptTerms,
                                  "$model",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(_vm.$v.acceptTerms, "$model", $$c)
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label",
                        attrs: { for: "inputAcceptTerms" }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.translate.login.iAcceptTerm1) +
                            "\n                            "
                        ),
                        _c(
                          "a",
                          { attrs: { target: "_blank", href: "/agb/" } },
                          [_vm._v(_vm._s(_vm.translate.login.iAcceptTerm2))]
                        )
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.formSubmitted
                  ? _c(
                      "span",
                      [
                        !_vm.$v.acceptTerms.required
                          ? _c("error-component", {
                              attrs: {
                                message: _vm.translate.login.readAndAccept
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("button-with-loading-component", {
                staticClass: "btn btn-primary btn-block mt-5",
                attrs: {
                  type: "submit",
                  text: _vm.translate.login.register,
                  loading: _vm.loading
                },
                nativeOn: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.onSubmit($event)
                  }
                }
              })
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c6ac4a2", { render: render, staticRenderFns: staticRenderFns })
  }
}